import { Backdrop, CircularProgress } from '@mui/material';

type FullScreenActionLoaderProps = {
  open: boolean;
};

const FullScreenActionLoader = ({ open }: FullScreenActionLoaderProps) => {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 2 }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default FullScreenActionLoader;
